<div class="site-footer">
    <div fxShow fxHide.lt-md>
        <ng-container *ngTemplateOutlet="desktop"></ng-container>
    </div>

    <div fxHide fxShow.lt-md>
        <ng-container *ngTemplateOutlet="mobile"></ng-container>
    </div>
</div>

<ng-template #desktop>
    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        <ul>
            <li class="link"><a style="color: inherit" href="https://shop.heringberlin.com" target="_blank">B2C</a></li>
        </ul>

        <ul>
            <li class="link" routerLink="/download" routerLinkActive="active" i18n="@@site-menu-footer_entry-downloads">
                Press &<br/>
                Downloads
            </li>
        </ul>

        <ul>
            <li class="link" routerLink="/terms-and-conditions" routerLinkActive="active"
                i18n="@@site-menu-footer_entry-terms-and-conditions">Terms & Conditions
            </li>
            <li class="link" routerLink="/privacy" routerLinkActive="active"
                i18n="@@site-menu-footer_entry-privacy-policy">Privacy & Cookie Policy
            </li>
        </ul>

        <ul>
            <li class="link" routerLink="/imprint" routerLinkActive="active" i18n="@@site-menu-footer_entry-imprint">
                Imprint
            </li>
        </ul>

        <ul>
            <li>© {{ currentYear }} · Stefanie Hering -<br/>
                Berlin GmbH
            </li>
        </ul>

        <ul>
            <div fxLayout fxLayoutGap="5%" class="socials">
                <a href="https://www.facebook.com/HeringBerlin" target="_blank">
                    <img alt="facebook"
                         src="./assets/images/social/facebook.png">
                </a>
                <a href="https://www.instagram.com/hering_berlin" target="_blank">
                    <img alt="instagram"
                         src="./assets/images/social/instagram.png">
                </a>
            </div>
        </ul>
    </div>
</ng-template>

<ng-template #mobile>
    <span class="to-top" (click)="scrollToTop()">↑</span>

    <div fxLayout="row wrap" fxLayoutAlign="space-around">
        <ul>
            <li class="link"><a style="color: inherit" href="https://shop.heringberlin.com" target="_blank">B2C</a></li>
            <li class="link" routerLink="/download" routerLinkActive="active" i18n="@@site-menu-footer_entry-downloads">
                Press & <br/>Downloads
            </li>
            <li class="link" routerLink="/contact" routerLinkActive="active" i18n="@@site-menu_entry-contact">Contact
            </li>
        </ul>

        <ul>
            <li class="link" routerLink="/terms-and-conditions" routerLinkActive="active"
                i18n="@@site-menu-footer_entry-terms-and-conditions">Terms & Conditions
            </li>
            <li class="link" routerLink="/privacy" routerLinkActive="active"
                i18n="@@site-menu-footer_entry-privacy-policy">Privacy & Cookie Policy
            </li>
            <li class="link" routerLink="/imprint" routerLinkActive="active" i18n="@@site-menu-footer_entry-imprint">
                Imprint
            </li>
            <li style="">© {{ currentYear }} · Stefanie Hering -<br/>
                Berlin GmbH
            </li>
        </ul>

        <div fxLayout fxLayoutGap="2.5%" class="socials" fxLayoutAlign="center">
            <a href="https://www.facebook.com/HeringBerlin" target="_blank">
                <img alt="facebook"
                     src="./assets/images/social/facebook.png">
            </a>
            <a href="https://www.instagram.com/hering_berlin" target="_blank">
                <img alt="instagram"
                     src="./assets/images/social/instagram.png">
            </a>
        </div>
    </div>
</ng-template>
